import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-transaction-detail-footer-shared",
  templateUrl: "./transaction-detail-footer-shared.component.html",
  styleUrls: ["./transaction-detail-footer-shared.component.scss"],
})
export class TransactionDetailFooterSharedComponent implements OnInit {
  taxAliasValue: string = this.cookieService.get("taxAliasValue");
  @Input() checkingComponent: any;
  @Input() paymentReceipt: any;
  @Input() currency: any;
  @Input() promoCodeValue: any;
  @Input() deliveryFee: any;
  @Input() editOrdenSecondStep: Boolean;
  @Input() refundModalPageOne: Boolean;
  @Input() voidModalPageOne: Boolean;
  @Input() refundModalPageTwo: Boolean;
  @Input() voidModalPageTwo: Boolean;
  @Input() pRefundModalPageOne: Boolean;
  @Input() pRefundModalPageTwo: Boolean;
  @Input() cRefundModalPageOne: Boolean;
  @Input() cRefundModalPageTwo: Boolean;
  @Input() receiptModal: Boolean;
  @Input() globalAmount: any;
  @Input() refundReason: any;
  @Input() closeOrderLoader: any;
  @Input() closeOrderStatus: any;
  @Input() totalPartialRefund: any;
  @Input() totalCustomRefund: any;
  @Input() refundPartialItems: any;
  @Input() editOrderLoader: Boolean;
  @Input() voidOrderLoader: Boolean;
  @Input() refundProductList: any[];
  @Output() sendReceipt: EventEmitter<any> = new EventEmitter();
  @Output() fullRefund: EventEmitter<any> = new EventEmitter();
  @Output() goToRefundPageTwo: EventEmitter<any> = new EventEmitter();
  @Output() goToVoidPageTwo: EventEmitter<any> = new EventEmitter();
  @Output() fullPaymentRefund: EventEmitter<any> = new EventEmitter();
  @Output() voidPayment: EventEmitter<any> = new EventEmitter();
  @Output() closeOrder: EventEmitter<any> = new EventEmitter();
  @Output() partialRefund: EventEmitter<any> = new EventEmitter();
  @Output() customRefund: EventEmitter<any> = new EventEmitter();
  @Output() goToPRefundPageTWo: EventEmitter<any> = new EventEmitter();
  @Output() goToCRefundPageTWo: EventEmitter<any> = new EventEmitter();
  @Output() partialPaymentRefund: EventEmitter<any> = new EventEmitter();
  @Output() customPaymentRefund: EventEmitter<any> = new EventEmitter();
  @Output() editOrder: EventEmitter<any> = new EventEmitter();
  @Output() voidOrder: EventEmitter<any> = new EventEmitter();
  storedItem: any;

  constructor(public offcanvasService: NgbOffcanvas,
    private router: Router, private cookieService: CookieService) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // this.disableButton = this.router.url.includes('/service-charges');
    //     if (event.url.includes('/service-charges')) {
    //       this.disableButton = true;
    //     console.log("DISABLE-BUTTON_TRUE", this.disableButton)
    //     } else {
    //       this.disableButton = false;
    //       console.log("DISABLE-BUTTON_FALSE", this.disableButton);
    //     }
    //   }
    // });
  }

  disableButton: boolean = false;
  isVoidTransaction = false;
  ngOnInit(): void {
    console.log("POP-UP DETAIL-FOOTER-SHARED", this.paymentReceipt)
    console.log("this.checkingComponent", this.checkingComponent);

    if (!Boolean(this.currency)) {
      this.currency = "$";
    }

    this.isTransactionVoid(this.paymentReceipt);

    this.getDiscountNames(this.paymentReceipt)

    this.storedItem = JSON.parse(localStorage.getItem('userData'))?.response?.role?.permissions?.filter((item) => item.permissionName === 'Order')[0];
    // this.setupRouteChangeListener();
    // console.log("DISABLE-BUTTON_NGONINIT@@", this.disableButton);
  }

  //  setupRouteChangeListener() {
  //   this.router.events.subscribe((event) => {
  //     if (event instanceof NavigationEnd) {
  //       if (event.url.includes('/service-charges')) {
  //         this.disableButton = true;
  //         console.log("DISABLE-BUTTON_TRUE", this.disableButton);
  //       } else {
  //         this.disableButton = false;
  //         console.log("DISABLE-BUTTON_FALSE", this.disableButton);
  //       }
  //     }
  //   });
  // }

  floatnumber(a) {
    +a;
    return Number(Math.round(a * 100) / 100).toFixed(2);
  }
  partialRefundCheck(paymentReceipt: any) {
    // console.log("PARTIALL-REFFF-CHECK", paymentReceipt)
    if (
      paymentReceipt?.orderId?.orderSellStatus === 8 ||
      paymentReceipt?.orderId?.orderSellStatus === 7 ||
      paymentReceipt?.orderId?.orderSellStatus === 6 ||
      paymentReceipt?.orderId?.orderSellStatus === 3 ||
      paymentReceipt?.transactionIds[0].transactionStatus == 7 ||
      paymentReceipt.transactionIds[0].transactionStatus == 6
    ) {
      return true;
    } else {
      false;
    }
  }
  editOrderCheck(paymentReceipt: any) {
    // console.log("Edit-ORDER-CHECK", paymentReceipt)
    if (
      paymentReceipt.transactionIds[0].transactionStatus == 4 ||
      paymentReceipt.transactionIds[0].transactionTypeId === 30 ||
      !this.editOrdenSecondStep
    ) {
      return true;
    } else {
      return false;
    }
  }

  isTransactionVoid(paymentReceipt: any) {
    // console.log("Edit-OR", paymentReceipt)
    if (
      paymentReceipt.transactionIds[0].transactionTypeId == 16 ||
      paymentReceipt.transactionIds[0].transactionTypeId == 30
    ) {
      console.log("VOID-TRANSACTION")
      this.isVoidTransaction = true;
      return true;
    } else {
      console.log("NOT-VOID-TRANSACTION")
      this.isVoidTransaction = false;
      return false;
    }
  }

  customRefundCheck(paymentReceipt: any) {
    console.log("CUSTOM-REFUNDD-CHECK", paymentReceipt)
    if (
      (paymentReceipt.orderId.orderSellStatus === 5 &&
        paymentReceipt.orderId.orderSellStatus !== 4 &&
        paymentReceipt?.orderId?.orderSellStatus !== 3) ||
      paymentReceipt.orderId.orderSellStatus < 3 ||
      paymentReceipt?.orderId?.orderSellStatus === 6
    ) {
      return true;
    } else {
      return false;
    }
  }
  sendReceiptFunc(item: any) {
    this.sendReceipt.emit(item);
    console.log("SEND-RECIIPT", item)
  }

  getCustomRefundAmount() {
    // filter the transactionAmount if transactionStatus == 4 from transactionIds
    const transactionAmount = this.paymentReceipt.transactionIds.filter(
      (transaction) => transaction.transactionStatus == 4
    );
    // console.log("TRANSACTION-AMOUNT", transactionAmount)
    return transactionAmount[0]?.transactionAmount || 0;
  }

  getTaxNames(): string {
    const taxNamesSet = new Set<string>();

    if (this.paymentReceipt?.orderId?.seats !== undefined && this.paymentReceipt?.orderId?.seats !== null) {
      for (const seat of this.paymentReceipt?.orderId?.seats) {
        for (const orderProduct of seat.orderProducts) {
          for (const productTax of orderProduct.productTax) {
            let taxPhrase = '';
            if (productTax.taxType !== 1) {
              taxPhrase = `${productTax.taxName} @${productTax.taxValue.toFixed(2)}${this.currency}`;
              taxNamesSet.add(taxPhrase);
            }
            else {
              taxPhrase = `${productTax.taxName} @${productTax.taxValue}%`;
              taxNamesSet.add(taxPhrase);
            }
          }
        }
      }
    }

    const taxNamesPhrase = Array.from(taxNamesSet).join(', ');

    return taxNamesPhrase
  }

  // _getDiscountNames: string;;;getDiscountNames = (receipt:any) : void => {
  //   const discountNamesSet = [];
  //   const seats = receipt?.orderId?.seats
  //   if(seats !== undefined){
  //     for(let item of seats){
  //       for(let orderProduct of item.orderProducts){
  //         const { productDiscount: { discountName, discountValue } } = orderProduct
  //           if(discountName && discountValue){
  //             discountNamesSet.push(`${discountName} @${discountValue}%`);
  //           }
  //       }
  //     }
  //   }
  //   this._getDiscountNames = discountNamesSet.length ? `(${discountNamesSet.join(', ')})` : null
  // }
  _getDiscountNames: string;
  getDiscountNames = (receipt: any): void => {
    const discountNamesSet = [];
    const seats = receipt?.orderId?.seats
    if (seats !== undefined) {
      for (let item of seats) {
          for (let orderProduct of item.orderProducts) {
              const { productDiscount: { discountName, discountValue, discountType } } = orderProduct
              if (discountName && discountValue) {
                  let discountSymbol = '';
                  let discountString = '';
                  if (discountType === 1) {
                      discountSymbol = '%';
                      discountString = `${discountName} @ ${discountValue}${discountSymbol}`;
                  } else if (discountType === 2) {
                      discountSymbol = this.currency;
                      discountString = `${discountName} @ ${discountSymbol}${discountValue}`;
                  }
                  discountNamesSet.push(discountString);
              }
          }
      }
  }
    this._getDiscountNames = discountNamesSet.length ? `(${discountNamesSet.join(', ')})` : null
  }


  fullRefundFunc(item: any) {

    this.fullRefund.emit(item);
    console.log("Full-REFFF", item)
  }
  voidOrderFunc(event: any) {
    this.voidOrder.emit(event);
    console.log("VOID-ORDER", event)
  }
  goToRefundPageTwoFunc() {
    this.goToRefundPageTwo.emit();
  }
  goToVoidPageTwoFunc() {
    this.goToVoidPageTwo.emit();
  }
  // ## TO SHOW ERROR MSG IN MODAL ITSELF AND NOT IN TOASTR
  // fullRefundErrMsg = "";
  fullPaymentRefundFunc(event: any) {
    // if (
    //   event.orderId.orderSellStatus == 4 ||
    //   event.orderId.orderSellStatus == 5
    // ) {
    //   this.fullRefundErrMsg = "";
    this.fullPaymentRefund.emit(event);
    // } else {
    //   this.fullRefundErrMsg = "You can do fullrefund for order status  Completed or Cancelled"
    //   }
  }
  voidPaymentFunc(event: any) {
    this.voidPayment.emit(event);
  }
  isClosed = false
  closeOrderFunc(event: any) {
    console.log("CLICKED_CLOSE_ORDER")
    if (this.isClosed) {
      console.log("CLICKED_CLOSE_ORDER_IF")
      this.offcanvasService.dismiss("Cross click");
    } else {
      console.log("CLICKED_CLOSE_ORDER_ELSE")
      this.closeOrder.emit(event);
      console.log("CLOSE-ORDER", this.closeOrderStatus)
      // ##ADDED THIS CHECK TO STOP THE UNEXPECTED BEHAVVIOUR ON FRONTEND BECAUSE OF THE API FAILURE AND orderSellStatus = 4 CHANGED...
      // ### CAN BE REMOVED IF THE API IS FIXED
      if (this.closeOrderStatus) {
        console.log("CLOSE-ORDER_TRUE", this.closeOrderStatus)
        this.paymentReceipt.orderId.orderSellStatus = 4;
        this.isClosed = true;
      } else {
        return;
      }
    }

  }
  partialRefundFunc(event: any) {
    this.totalPartialRefund = 0.0;
    this.partialRefund.emit(event);
    console.log("PARTIALL-REFFF", event)
  }
  customRefundFunc(event: any) {
    console.log("CUSTOM-REFUNDD", event);

    this.customRefund.emit(event);
    console.log("CUSTOM-REFUNDD", event)
  }
  editOrderFunc(event: any) {
    this.editOrder.emit(event);
    console.log("Edit-ORDER", event)
  }

  checkFullRefund(paymentReceipt: any) {
    if (
      paymentReceipt.orderId.orderSellStatus != 4 &&
      paymentReceipt.orderId.orderSellStatus != 5 &&
      paymentReceipt.orderId.orderSellStatus != 8
    ) {
      return true;
    } else if (paymentReceipt.transactionIds[0].transactionStatus == 7 || paymentReceipt.transactionIds[0].transactionStatus == 6) {
      return true;
    } else {
      return false;
    }
  }

  checkVoidPayment(paymentReceipt: any) {
    if (
      paymentReceipt.transactionIds[0].transactionStatus == 7 ||
      paymentReceipt.transactionIds[0].transactionStatus == 6
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkCloseOrder(paymentReceipt: any) {
    if (paymentReceipt.orderId.orderSellStatus === 4 || this.disableButton === true) {
      return true;
    } else if (paymentReceipt.transactionIds[0].transactionStatus == 7 || paymentReceipt.transactionIds[0].transactionStatus == 6) {
      return true;
    } else {
      return false;
    }
  }

  disableReasonBtn = false;
  checkSendReceipt(paymentReceipt: any) {
    const numericValue = parseFloat(this.totalCustomRefund);
    if (isNaN(numericValue) || numericValue <= 0) {
      // console.log("DISABLE_BUTTON");
      this.disableReasonBtn = true;
    } else {
      // console.log("ENABLE_BUTTON");
      this.disableReasonBtn = false;
    }
    if (
      paymentReceipt.paymentStatus != 1 &&
      paymentReceipt.paymentStatus != 2 &&
      paymentReceipt.paymentStatus != 3 &&
      paymentReceipt.paymentStatus != 4 &&
      paymentReceipt.paymentStatus != 5
    ) {
      return true;
    } else {
      return false;
    }
  }
  goToPRefundPageTwoFunc() {
    this.goToPRefundPageTWo.emit();
  }

  goToCRefundPageTwoFunc() {
    this.goToCRefundPageTWo.emit();
  }
  partialPaymentRefundFunc(event) {
    this.partialPaymentRefund.emit(event);
    console.log("PARTIALL-REFFF-22222222", event)
  }

  customPaymentRefundFunc(event) {
    this.customPaymentRefund.emit(event);
    console.log("CUSTOM-REFUNDD-22222", event)
  }

}
